<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px" :useAutoOptional="false"
				:optional="selectData.length !== 1" @btnclick="update" :src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" :useAutoOptional="false"
				:optional="selectData.length === 0" @btnclick="del" :src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="proExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
		</div>
		<div class="TableWidth">
			<Commontable ref="ProviderRef" @onRowClick="onRowClick" colnum="7" :tableData="tableData"
				:headerData="headerData" height="100%" @handleSelectionChange="handleSelectionChange"></Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<DialogFrom width="1020px" :title="`${from.Code ? '编辑' : '新增'}发票判重档案`" :dialogVisible="dialogVisibles"
			@cancel="cancel" @dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item, index) of fromdataadd">
					<Commondropdownlist :key="index" ref="proadd" :options="item.options" :btx="item.btx"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
						:inputtype="item.inputtype" :width="item.width" :disabled="item.disabled" :event="item.event"
						:pt="item.pt" @remoteMethod="remoteMethod" @remoteHosType="remoteHosType"
						@remoteMethodtows="remoteMethodtows" @invClassChange="invClassChange">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这些数据吗？</span>
		</Dialog>
	</div>
</template>
<script>
import Commondropdownlist from '@/components/common-dropdownlist.vue'
import Commontable from '@/components/common-table.vue'
import Commonbtn from '@/components/common-btn.vue'
import Pagination from '@/components/pagination.vue'
import DialogFrom from '@/components/dialog-from.vue'
import Dialog from '@/components/dialog.vue'
import fromdata from '../fromData/add'
import headerData from '../headerData/headerData'
import {
	InventoryClassList
} from '@/api/home'
import { GetInvNameList } from '@/api/newsapi'
import {
	DeleteSaleBillRepeatInfo,
	AddSaleBillRepeatInfo,
	EditSaleBillRepeatInfo,
	GetSaleBillRepeatInfoInfo,
	GetHospitalList
} from '@/api/saleBillRepeatInfo'

export default {
	components: {
		Commontable,
		Commonbtn,
		Pagination,
		DialogFrom,
		Commondropdownlist,
		Dialog
	},
	props: {
		tableData: {
			type: Array,
			default: () => []
		},
		total: {
			type: Number,
			default: 0
		}
	},
	data: function () {
		return {
			selectData: [],
			dialogVisibles: false,
			dialogVisibledel: false,
			fromdataadd: [],
			headerData: [],
			from: {
				Code: "",
				InvClass: "",
				InvName: "",
				TerminalHPID: "",
				BuyerID: "",
				SellerID: "",
				SBDate: ""
			},
			qus: [],
			qx: {
				add: false,
				update: false,
				del: false,
				daoc: true,
			},
		}
	},
	mounted() {
		this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
		this.headerData = JSON.parse(JSON.stringify(headerData))
		this.QX()
	},
	methods: {
		QX() {
			let data = JSON.parse(localStorage.getItem("MenusData"));
			let MenuID = this.$route.query.MenuID;
			if (data && data.Menus && data.Menus.length > 0) {
				data.Menus[2].Nodes.map((item, index) => {
					if (item.NodeID == MenuID) {
						this.qus = item.Nodes;
					}
				});
			}
			if (this.qus) {
				this.qus.map((item, index) => {
					if (item.NodeName == "add") {
						this.qx.add = true;
					} else if (item.NodeName == "edit") {
						this.qx.update = true;
					} else if (item.NodeName == "delete") {
						this.qx.del = true;
					} else if (item.NodeName == "browse") {
						this.qx.browse = true;
					}
				});
			}
		},
		getSingleSelectedRow(actionName) {
			if (this.selectData.length !== 1) {
				this.$message.warning(`请勾选一条数据进行${actionName}！`)
				return null
			}
			return this.selectData[0]
		},
		// 新增
		async add() {
			let {
				code,
				message
			} = await AddSaleBillRepeatInfo({
				InvClass: this.from.InvClass,
				InvName: this.from.InvName,
				TerminalHPID: this.from.TerminalHPID,
				BuyerID: this.from.BuyerID,
				SellerID: this.from.SellerID,
				SBDate: this.from.SBDate
			})
			if (code == 0) {
				this.$message({
					type: 'success',
					message: '新增成功'
				});
				this.dialogVisibles = false
				this.$emit('handleCurrentChange', 1)
			} else {
				this.$message({
					type: 'error',
					message: message
				});
			}
		},
		// 详情
		async getInfo() {
			let {
				code,
				data
			} = await GetSaleBillRepeatInfoInfo({
				Code: this.from.Code,
			})
			if (code == 0 && data) {
				this.$refs.proadd[0].modelvalue = data.InvClass
				// set options so they render correctly
				this.fromdataadd[1].options = [{ key: data.InvName, value: data.InvName }]
				this.$refs.proadd[1].modelvalue = data.InvName
				this.fromdataadd[2].options = [{ key: data.TerminalHPID, value: data.TerminalHPName }]
				this.$refs.proadd[2].modelvalue = data.TerminalHPID
				this.fromdataadd[3].options = [{ key: data.BuyerID, value: data.BuyerName }]
				this.$refs.proadd[3].modelvalue = data.BuyerID
				this.fromdataadd[4].options = [{ key: data.SellerID, value: data.SellerName }]
				this.$refs.proadd[4].modelvalue = data.SellerID
				this.$refs.proadd[5].modelvalue = data.SBDate
			}
		},
		// 修改
		async edit() {
			let {
				code,
				message
			} = await EditSaleBillRepeatInfo({
				Code: this.from.Code,
				InvClass: this.from.InvClass,
				InvName: this.from.InvName,
				TerminalHPID: this.from.TerminalHPID,
				BuyerID: this.from.BuyerID,
				SellerID: this.from.SellerID,
				SBDate: this.from.SBDate
			})
			if (code == 0) {
				this.$message({
					type: 'success',
					message: '修改成功'
				});
				this.dialogVisibles = false
				this.$parent.getList()
			} else {
				this.$message({
					type: 'error',
					message: message
				});
			}
		},
		adduser() {
			this.from = {
				Code: "",
				InvClass: "",
				InvName: "",
				TerminalHPID: "",
				BuyerID: "",
				SellerID: "",
				SBDate: ""
			};
			this.getInventoryClassList();
			this.fromdataadd[1].options = []
			this.fromdataadd[2].options = []
			this.fromdataadd[3].options = []
			this.fromdataadd[4].options = []
			this.dialogVisibles = true
		},
		cancel() {
			this.$refs.proadd[0].modelvalue = "";
			this.$refs.proadd[1].modelvalue = "";
			this.$refs.proadd[2].modelvalue = "";
			this.$refs.proadd[3].modelvalue = "";
			this.$refs.proadd[4].modelvalue = "";
			this.$refs.proadd[5].modelvalue = "";
			this.dialogVisibles = false
		},
		onRowClick(val) {
			this.from.Code = val.Code
		},
		update() {
			const row = this.getSingleSelectedRow('修改')
			if (!row) return
			this.from.Code = row.Code
			this.getInventoryClassList();
			this.getInfo();
			this.dialogVisibles = true
		},
		dialogOK() {
			this.from.InvClass = this.$refs.proadd[0].modelvalue
			this.from.InvName = this.$refs.proadd[1].modelvalue
			this.from.TerminalHPID = this.$refs.proadd[2].modelvalue
			this.from.BuyerID = this.$refs.proadd[3].modelvalue
			this.from.SellerID = this.$refs.proadd[4].modelvalue
			this.from.SBDate = this.$refs.proadd[5].modelvalue
			this.from.Code ? this.edit() : this.add()
		},
		// 产品线下拉
		async getInventoryClassList() {
			let {
				code,
				data
			} = await InventoryClassList({})
			if (code == 0) {
				this.fromdataadd[0].options = []
				data.data.map((item) => {
					this.fromdataadd[0].options.push({
						key: item.InvClass,
						value: item.InvClassName
					})
				})
			}
		},
		invClassChange(val) {
			// If InvClass changes, you might want to clear InvName
			this.$refs.proadd[1].modelvalue = ""
			this.fromdataadd[1].options = []
		},
		// 产品名称检索
		async remoteMethod(query) {
			if (query !== "") {
				let { code, data } = await GetInvNameList({
					InvName: query,
					InvClass: this.$refs.proadd[0].modelvalue || ""
				});
				if (code == 0) {
					let arr = [];
					data.map((item) => {
						arr.push({
							key: item.InvName,
							value: item.InvName
						});
					});
					this.fromdataadd[1].options = arr;
				}
			} else {
				this.fromdataadd[1].options = [];
			}
		},
		// 医院检索
		async remoteHosType(query) {
			if (query !== "") {
				let { code, data } = await GetHospitalList({
					HosType: "医院",
					HPName: query,
					pageIndex: 1,
					pageSize: 50
				});
				if (code == 0 && data && data.data) {
					let arr = [];
					data.data.map((item) => {
						arr.push({
							key: item.HPID || item.ID,
							value: item.HPName || item.HospitalName
						});
					});
					this.fromdataadd[2].options = arr;
				}
			} else {
				this.fromdataadd[2].options = [];
			}
		},
		// 付款方/销售方检索
		async remoteMethodtows(query) {
			if (query !== "") {
				let { code, data } = await GetHospitalList({
					HPName: query,
					pageIndex: 1,
					pageSize: 50
				});
				if (code == 0 && data && data.data) {
					let arr = [];
					data.data.map((item) => {
						arr.push({
							key: item.HPID || item.ID,
							value: item.HPName || item.HospitalName
						});
					});
					this.fromdataadd[3].options = arr;
					this.fromdataadd[4].options = arr;
				}
			} else {
				this.fromdataadd[3].options = [];
				this.fromdataadd[4].options = [];
			}
		},
		//复选框选中
		handleSelectionChange(e) {
			this.selectData = e;
		},
		canceldel() {
			this.dialogVisibledel = false
		},
		dialogOKdel() {
			this.deleteInfo()
			this.dialogVisibledel = false
		},
		del() {
			if (this.selectData.length === 0) {
				this.$message.warning(`请勾选数据进行删除！`)
				return
			}
			this.dialogVisibledel = true
		},
		// 删除
		async deleteInfo() {
			let {
				code,
				message
			} = await DeleteSaleBillRepeatInfo({
				Codes: this.selectData.map(it => it.Code),
			})
			if (code == 0) {
				this.$message({
					type: 'success',
					message: '删除成功'
				});
				this.selectData = [];
				this.$parent.getList()
			} else {
				this.$message({
					type: 'error',
					message: message
				});
			}
		},
		//导出
		proExport() {
			this.$emit('proExport')
		},
		handleCurrentChange(pageindex) {
			this.$emit('handleCurrentChange', pageindex)
		},
		handleSizeChange(paegSzie) {
			this.$emit('handleSizeChange', paegSzie)
		}
	}
}
</script>

<style lang="less" scoped>
.incenters {
	height: 100%;

	.pagination {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 16px;
		padding-bottom: 16px;
	}

	.from {
		width: 100%;
	}
}
</style>